// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { Message, EventType } from '../../types/messageTypes'

const SnackbarComponent: React.FC = () => {
  // messages aus den Professocial Modulen anzeigen
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    window.addEventListener('ProfessocialMessage', (({ detail }: CustomEvent) => {
      const message: Message = detail
      if (message && message.eventType !== EventType.load) {
        enqueueSnackbar(message.message,
          {
            variant: message.severity,
          })
      }
    }) as EventListener)
  },
  [],
  )

  return (
    <>
    </>
  )
}

export default SnackbarComponent
